exports = module.exports = require("./../../../node_modules/.npminstall/css-loader/0.23.1/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".menu-paper{width:100%;position:absolute;top:0;bottom:0}.menu-paper .menu-head{text-align:center}.menu-paper .menu-head .logo{margin:30px auto;display:block;width:auto}.menu-paper .menu-head .search-paper{display:inline-block;margin:auto}.menu-paper .menu-head .search-paper input{-webkit-transition:all .3s;transition:all .3s;padding:0 10px!important;width:90%!important}.menu-paper .menu-head .search-paper input:active,.menu-paper .menu-head .search-paper input:focus,.menu-paper .menu-head .search-paper input:hover{width:100%!important}.menu-paper .menu .open>.menu-btn-wrap .menu-btn{background:rgba(0,0,0,.05)}.menu-paper .menu .active>.menu-btn-wrap .menu-btn{color:#fff;background:#ee6e73}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/.npminstall/css-loader/0.23.1/css-loader!./~/.npminstall/postcss-loader/0.8.2/postcss-loader!./~/.npminstall/less-loader/2.2.3/less-loader!./src/components/Menus/index.less
 ** module id = 515
 ** module chunks = 0
 **/